import React from 'react';
import PropTypes from 'prop-types'; 
import { Header, Footer } from './../../components/index'
import 'fontsource-roboto';
import './Layout.css'

export default function Layout({children, email}){
  return(
    <div style={{fontFamily: "Roboto"}}>
      <Header 
        email={email} 
      />
      <div className="container">
        {children}
      </div>
      <Footer />
    </div>
  )

}

Layout.propTypes = {
  children: PropTypes.element.isRequired
}